<template>
    <div class="title-tip">
        <slot />
    </div>
</template>
<script>
export default {
};
</script>
<style lang="scss" scoped>
.title-tip {
    padding: 13px 30px;
    color: $--color-base;
    text-align: center;
    margin-bottom: 30px;
    position: relative;
    line-height: 14px;
    z-index: 9;

    &::before {
        content: "";
        background-color: rgba($color: $--color-base, $alpha: 0.1);
        position: absolute;
        top: 0px;
        left: -40px;
        right: 0px;
        height: 100%;
        width: calc(100% + 80px);
        z-index: 0;
    }
}
</style>
